export default __webpack_public_path__ + "c95d30a96b9f4ba7c239c952953b87b9.svg";